/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1PlusIcon20Solid = forwardRef('People1PlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.168 6.168a4.167 4.167 0 1 1-8.335 0 4.167 4.167 0 0 1 8.335 0Z" }),
        React.createElement("path", { d: "M13.09 12.269C11.959 12.037 10.842 12 10 12c-2.362 0-6.887.29-7.827 4.369C1.97 17.252 2.735 18 3.641 18h7.123a3.008 3.008 0 0 1 2.326-5.731Z" }),
        React.createElement("path", { d: "M17 13a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" })));
});
